var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park:target-one"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.2937 73.9603C60.6845 73.9603 73.9603 60.6845 73.9603 44.2937C73.9603 27.9028 60.6845 14.627 44.2937 14.627C27.9028 14.627 14.627 27.9028 14.627 44.2937C14.627 60.6845 27.9028 73.9603 44.2937 73.9603Z",
    stroke: "#ED5272",
    strokeWidth: 7.41667,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.2938 59.1269C52.4892 59.1269 59.1271 52.489 59.1271 44.2935C59.1271 36.0981 52.4892 29.4602 44.2938 29.4602C36.0984 29.4602 29.4604 36.0981 29.4604 44.2935C29.4604 52.489 36.0984 59.1269 44.2938 59.1269Z",
    stroke: "white",
    strokeWidth: 7.41667,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M44.2938 48.0019C46.3334 48.0019 48.0021 46.3331 48.0021 44.2935C48.0021 42.254 46.3334 40.5852 44.2938 40.5852C42.2542 40.5852 40.5854 42.254 40.5854 44.2935C40.5854 46.3331 42.2542 48.0019 44.2938 48.0019Z",
    fill: "#ED5272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.2935 14.6269V7.21021",
    stroke: "#ED5272",
    strokeWidth: 7.41667,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M70.2521 81.3769L62.8354 68.3977",
    stroke: "#ED5272",
    strokeWidth: 7.41667,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.7522 68.3977L18.3354 81.3769",
    stroke: "#ED5272",
    strokeWidth: 7.41667,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.03507d12f5ddff0b567bbf53803147cc.svg";
export { ForwardRef as ReactComponent };